import axios from "axios";
import { rollbar } from "./ErrorBoundary/index.js";

// Set up axios response interceptor for global error handling
axios.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Only report to Rollbar if it's configured and enabled
    if (rollbar && rollbar.configure) {
      try {
        let shouldReport = false;
        let context = "API_ERROR";

        // Check if it's a subscription-related endpoint
        const isSubscriptionEndpoint = error.config?.url && (
          error.config.url.includes('/subscribe') ||
          error.config.url.includes('/validate-subscription') ||
          error.config.url.includes('/unsubscribe')
        );

        if (error.response) {
          // Report 5xx errors for all endpoints
          if (error.response.status >= 500) {
            shouldReport = true;
          }
          // Report 4xx errors for subscription endpoints only, excluding 403 (legitimate subscription limits)
          else if (error.response.status >= 400 && error.response.status !== 403 && isSubscriptionEndpoint) {
            shouldReport = true;
            context = "SUBSCRIPTION_CLIENT_ERROR";
          }
        } else {
          // Network errors (no response) for subscription endpoints
          if (isSubscriptionEndpoint) {
            shouldReport = true;
            context = "SUBSCRIPTION_NETWORK_ERROR";
          }
        }

        if (shouldReport) {
          // Extract useful information from the error
          const errorInfo = {
            context,
            url: error.config?.url,
            method: error.config?.method?.toUpperCase(),
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            // Add request data for non-GET requests (but limit size to avoid too much data)
            requestData:
              error.config?.method?.toLowerCase() !== "get" && error.config?.data
                ? typeof error.config.data === "string"
                  ? error.config.data.substring(0, 1000)
                  : error.config.data
                : undefined,
            // Add network error details
            isNetworkError: !error.response,
            errorMessage: error.message,
          };

          // Report to Rollbar with context
          rollbar.error(error, errorInfo);
        }
      } catch (rollbarError) {
        // If Rollbar fails, just log it - don't break the app
        console.error("Failed to report error to Rollbar:", rollbarError);
      }
    }

    // Re-throw the error so existing error handling continues to work
    return Promise.reject(error);
  }
);

export default axios;
